export * from './collections'

// TODO: Make it dynamic based on environments
export const REGION = 'europe-west3'
